const hero = {
  leading: "I'm Tatsuro",
  subleading: 'I love coding with',
  skills: ['React', 'Gatsyby', 'Laravel', 'Vue', 'Docker'],
}

export { hero }
